import {ScrapyCollectionsAdmin} from '../components/admin/ScrapyCollectionsAdmin';

export function CollectionsPage() {
  return (
    <div className="p-4">
      <ScrapyCollectionsAdmin />
    </div>
  );
}
